import { render, staticRenderFns } from "./candidate-dossier-records.vue?vue&type=template&id=42ed2bf0&"
import script from "./candidate-dossier-records.vue?vue&type=script&lang=js&"
export * from "./candidate-dossier-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports